import { INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE } from './InstallableAppByManualUrlInstallMode';
import { INSTALLABLE_APP_DEFAULT_INSTALL_MODE } from './InstallableAppDefaultInstallMode';
export function foldInstallInstallableAppInstallMode(installableAppInstallMode) {
  return function foldInstallInstallableAppInstallModeInner(installableAppDefault, installableAppByManualUrl) {
    switch (installableAppInstallMode.type) {
      case INSTALLABLE_APP_DEFAULT_INSTALL_MODE:
        return installableAppDefault(installableAppInstallMode);
      case INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE:
        return installableAppByManualUrl(installableAppInstallMode);
      default:
        // Flow compile-time validation that we've handled every discover item
        // prettier-ignore
        installableAppInstallMode;
        return undefined;
    }
  };
}